<template>
  <div class="A05_gsdt">
    <div class="title">
      <div class="txtStyle">公司动态</div>
      <div class="bj"></div>
    </div>
    <div class="article list">
      <ul>
        <li
          class="list_"
          v-for="(item, index) in list"
          :key="index"
          @click="toDetail(item.id)"
        >
          <img :src="item.img" class="left" alt="" />
          <div class="right">
            <div class="r_top">
              <span class="r_top_l">{{ item.title }}</span>
              <span class="r_top_r">{{ item.published }}</span>
            </div>
            <p class="text">{{ item.brief }}</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="zlpage">
      <el-pagination
        :key="pages.current"
        id="FY"
        @current-change="pagefun"
        background
        layout="prev, pager, next"
        :total="pages.total"
        :current-page="pages.current"
        :page-size="pages.size"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "A05_gsdt",
  data() {
    return {
      list: [],
      currentPage: 1, //初始页
      courseId: "", //后端需要的参数，看个人是否需要
      pageSize: 10, //每页的数据
      pageNum: 1, //后端需要的参数，看个人是否需要

      pages: {
        current: 1,
        total: 5,
        size: 5,
      },
    };
  },
  mounted() {
    var cur = localStorage.getItem("gsdt");
    this.pages.current = Number(cur);
    this.getlist();
  },
  methods: {
    getlist: function () {
      var updata = {
        page: this.pages.current,
        limit: this.pages.size,
      };
      this.$api.dynamic_list(updata).then((res) => {
        if (res.code == 0) {
          this.list = res.data.list == null ? [] : res.data.list;
          this.pages.total = res.data.total;
          this.list.map(function (item, index) {
            item.published = item.published.split(" ")[0];
          });
        }
      });
    },
    pagefun: function (p) {
      this.pages.current = p;
      localStorage.setItem("gsdt", p);
      this.getlist();
    },
    toDetail: function (id) {
      this.$router.push({
        name: "B05_gsdt",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.A05_gsdt {
  width: 1077px;
  min-height: 860px;
  margin-left: 256px;
}
.title {
  position: relative;
  width: 710px;
  height: 56px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 56px;
  color: #1d1d1d;
  font-size: 40px;
  text-align: center;
  line-height: 56px;
  margin: 0 auto;
  /* margin: 20px 0px 20px 287px; */
}
.txtStyle {
  line-height: 56px;
}
.bj {
  position: absolute;
  top: 20px;
  /* left: 598px; */
  width: 778px;
  height: 16px;
  background: url("../../common/images/investCenter/textBj.png") no-repeat;
}
/* 分页 */
#FY /deep/ .el-pager .number {
  border-radius: 4px;
}
#FY /deep/ .el-pager .active {
  background-color: #e7413b;
}
#FY /deep/ .el-pager .number:not(.active):hover {
  color: #666;
}

.zlpage {
  overflow: hidden;
  margin: 0 auto;
}
.list,
.list ul {
  width: 100%;
  overflow: hidden;
}
.list ul {
  padding-bottom: 30px;
}
.list .list_ {
  width: 1077px;
  display: flex;
  justify-content: left;
  overflow: hidden;
  margin: 0 auto;
  padding-bottom: 24px;
  border-bottom: 1px solid #d5d5d5;
  padding-top: 30px;
  cursor: pointer;
}
.list_ .left {
  display: inline-block;
  width: 180px;
  height: 120px;
}
.list_ .right {
  display: inline-block;
  width: 874px;
  margin-left: 26px;
}
.r_top {
  width: 100%;
  overflow: hidden;
}
.r_top .r_top_l {
  width: 710px;
  font-size: 28px;
  padding-right: 40px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 40px;
  text-align: left;
  float: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.list_:hover .r_top_l {
  color: #e7413b;
}
.r_top .r_top_r {
  width: 120px;
  font-size: 20px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 40px;
  float: left;
  text-align: left;
}
.text {
  width: 100%;
  font-size: 20px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 32px;
  margin-top: 13px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/aboutS/A05_gsdt.vue